export const INVALID_CREDENTIAL_EXCEPTION = "InvalidCredentialsException";
